import {makeActionCreator} from '~/shared/store/redux-toolbelt';
import {getUserDevice} from '~/shared/utils/userAgent';

export const setUserDevice = makeActionCreator<'setUserDevice', ReturnType<typeof getUserDevice>>('setUserDevice');
export const setCurrentWindowWidth = makeActionCreator<'setCurrentWindowWidth', number | undefined>(
  'setCurrentWindowWidth',
);
